export default {
  search: ['请输入您要搜索的特殊授权名称', 'Please enter the permission name'],
  name: ['特殊授权名称', 'Permission'],
  key: ['特殊授权代码', 'Permission Key'],
  note: ['备注', 'Note']
};
